export default __webpack_public_path__ + "static/media/image7.6269e8fe.jpg";